import { uniqueId } from "lodash";
import { t } from "../../../../services";
import { certificateAction, strCode } from "../../../../consts";

const parseLogs = (logs) => {
  const parsedLogList = logs.map((logItem) => {
    const id = uniqueId();

    const { firstName, lastName, email } = logItem ?? {};

    let author = email;
    if (firstName && lastName) {
      author = `${logItem?.firstName} ${logItem?.lastName}`;
    }

    return { ...logItem, id, author };
  });

  return parsedLogList;
};

const getLogAction = (logItem) => {
  switch (logItem?.action) {
    case certificateAction.GENERATE:
      return t(strCode.GENERATE_ACTION);

    case certificateAction.DOWNLOAD:
      return t(strCode.DOWNLOAD_ACTION);

    case certificateAction.REVOKE:
      return t(strCode.REVOKE_ACTION);
    default:
      return logItem?.action;
  }
};

export const historyLogsParserUtils = {
  parseLogs,
  getLogAction
};
